import React from "react";
import NavBar from "../components/Navigation/NavBar/NavBar";
import SideDrawer from "../components/Navigation/SideDrawer/SideDrawer";
import classes from "./Layout.module.css";

type Props = {
    extraClasses?: string;
};

const Layout: React.FC<Props> = (props) => {
    const [sideDrawerIsOpen, setSideDrawerIsOpen] = React.useState(false);

    const toggleSideDrawer = () => {
        setSideDrawerIsOpen(!sideDrawerIsOpen);
    };

    return (
        <div>
            <NavBar sideDrawerToggleClick={toggleSideDrawer} />
            <SideDrawer show={sideDrawerIsOpen} backdropClickHandler={toggleSideDrawer} />
            <main className={[classes.Content, props.extraClasses].join(" ")}>{props.children}</main>
        </div>
    );
};

export default Layout;
